import { reducerFromActionHandlers } from '../../../shared/utils/redux/utils.reducers'
import { LoaderActions } from './loader.actions'

export const reducer = reducerFromActionHandlers(0, [
  { actionType: LoaderActions.start.CREATE, handler: state => state + 1 },
  { actionType: LoaderActions.stop.CREATE, handler: state => state - 1 },
])
